import { Icon } from '@instinet-analytics/semantic-ui-components';
import { Tooltip } from '@instinet-analytics/core-lib';
import React from 'react';
import './WarningPanel.scss';

export function WarningPanel(props: { text: string }) {
    const { text } = props;
    return (
        <div className="WarningPanel">
            <div className="warning-icon">
                <Icon name="warning circle" />
            </div>
            <div className="text">
                <Tooltip text={text}>{text}</Tooltip>
            </div>
        </div>
    );
}
